import React, { useState } from 'react';
import { AgeGate, readAgeVerification } from './components/AgeGate';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Etiquette } from './components/Etiquette';
import { Screening } from './components/Screening';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { EditorialBand } from './components/EditorialBand';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  // Resolve verification SYNCHRONOUSLY before the first paint so the site
  // never flashes underneath the gate.
  const [verified, setVerified] = useState<boolean>(() => readAgeVerification());
  if (!verified) {
    return <div className="w-full min-h-screen bg-ink" data-id="element-0">
        <AgeGate onVerified={() => setVerified(true)} data-id="element-1" />
      </div>;
  }
  return <div className="w-full min-h-screen bg-ink" data-id="element-2">
      <Navigation data-id="element-3" />
      <Hero data-id="element-4" />
      <About data-id="element-5" />
      <Services data-id="element-6" />
      <Etiquette data-id="element-7" />
      <Screening data-id="element-8" />
      <Testimonials data-id="element-9" />
      <FAQ data-id="element-10" />
      <EditorialBand data-id="element-11" />
      <Contact data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}